import { env } from "./EnvironmentConfig";

export const APP_NAME = "OMT";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";

/** Default home after login and /app redirect (KCRA-style dashboard, not calendar/tasks). */
export const APP_LANDING_PATH = `${APP_PREFIX_PATH}/analytics/obligation-overview`;

export const THEME_CONFIG = {
  navType: "SIDE",
  sideNavTheme: "SIDE_NAV_DARK",
  navCollapsed: false,
  topNavColor: "#1245A8",
  headerNavColor: "rgb(18, 69, 168)",
  locale: "en",
  currentTheme: "light",
  direction: "ltr",
};
